var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"release-app inner-app"},[_c('router-view',{staticClass:"inner-app-content"}),(_vm.isLoading)?_c('Loader',{attrs:{"fullScreen":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }